import { gql } from '@apollo/client'
import { FILE_FRAGMENT, ONBOARDING_PART_FRAGMENT, WORKER_ONBOARDING_PART_FRAGMENT } from '../apollo.fragment'

export const GET_WORKER_ONBOARDING_OVERVIEW_QUERY = gql`
	query getWorkerOnboardingQuery {
		workerOnboardingOverview {
			id
			message
			percentageCompleted
			state
			companyOnboarding {
				companyId
				description
				id
				name
				onboardingPartsNumber
			}
			onboardingParts {
				workerOnboardingPart {
					...workerOnboardingPartFragment
				}
				...onboardingPartFragment
			}
		}
	}

	${ONBOARDING_PART_FRAGMENT}
	${WORKER_ONBOARDING_PART_FRAGMENT}
`

export const GET_WORKER_ONBOARDING_PART_QUERY = gql`
	query getWorkerOnboardingPart($id: String!) {
		onboardingPart(id: $id) {
			workerOnboardingPart {
				...workerOnboardingPartFragment
			}
		}
	}

	${WORKER_ONBOARDING_PART_FRAGMENT}
`

export const GET_WORKER_RESUMES_QUERY = gql`
	query workerResumesQuery($workerId: String!) {
		recruiterWorker(workerId: $workerId) {
			resumes {
				...fileFragment
			}
		}
	}

	${FILE_FRAGMENT}
`

export const RECRUITER_GET_WORKER_RESUMES_QUERY = gql`
	query recruiterWorkerResumesQuery($workerId: String!) {
		recruiterWorker(workerId: $workerId) {
			resume {
				...fileFragment
			}
		}
	}

	${FILE_FRAGMENT}
`
